import { useEffect, useRef } from 'react';
import { offlineStateService } from '../offline/services/offline-state.service.js';
import { syncEngine } from '../offline/sync/engine/sync-engine.js';

/**
 * When connectivity returns, trigger background sync instead of a full page reload.
 * Full reloads interrupted in-flight sync and left duplicate server records.
 */
export default function NetworkReloadHandler() {
  const syncedRef = useRef(false);

  useEffect(() => {
    offlineStateService.syncFromNavigator();

    if (!syncedRef.current && offlineStateService.isCurrentlyOnline()) {
      syncedRef.current = true;
      void syncEngine.forceSync();
    }

    const unsubscribe = offlineStateService.subscribe((state) => {
      if (state.isOnline && !syncedRef.current) {
        syncedRef.current = true;
        void syncEngine.forceSync();
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return null;
}
